export default __webpack_public_path__ + "static/media/close-white.42fe1ae9.svg";